<template>
  <div>
    <div class="container-top">
      <div class="container-title">
        <span>Blocks</span>
        <span>Total {{ total }} blocks (Show 10,000 latest records)</span>
      </div>

      <div class="container-selectPage">
        <div class="change-page">
          <span>Show</span>
          <div @click.stop="showRecordPage=!showRecordPage" class="change-page-num">
            <span>{{nowRecordPage}}</span>
            <img src="../../images/transtion/arrow-bottom.png"/>
            <div v-show="showRecordPage" class="change-page-num-click">
              <span v-for="(item,index) in recordPage" :key="index"  @click.stop="actionSelectPage(item)">{{item.num}}</span>
            </div>
          </div>
          <span>Records</span>
        </div>
        <paginationSp :config="cfg_pagination" @reloadList="getList()" class="py-3"/>
      </div>

    </div>
    <div class="bg-card mt-4">
      <table class="main-table w-100 text-right">
        <tr class="text-break">
          <td class="pl-4 text-left text-middle-bond" style="width: 10%" >
            BLOCK HEIGHT
          </td>
          <td class="text-left text-middle-bond" style="width: 10%">
            AGE
          </td>
          <td class="text-left text-middle-bond" style="width: 8%">
            TX COUNT
          </td>
          <td class="text-left text-middle-bond" style="width: 16%">
            VALIDATOR
          </td>
          <td class="text-left text-middle-bond" style="width: 17%">
            GAS USED
          </td>

        </tr>
        <tr v-for="(item,index) in data_onshow" :key="index" class="hover-bg transTable">
          <td class="mb-none text-left d-flex flex-row align-items-center">
            <div class="ml-4 trans-icon" style="width: 42px;height: 42px">
              <div class="block-icon-img"></div>
            </div>
            <div class="trans-success ml-3">
              <span><router-link :to="`/block/${item.number}`">{{item.number}}</router-link></span>
            </div>
          </td>
          <td class="text-left">
            <div class="trans-age-text">
              {{updateTimestamp(item.timestamp)}}
            </div>
          </td>
          <td class="text-left">
            <div class="trans-td-text">{{item.txsCount}}</div>
          </td>
        <!--  <td class="text-left">
            <div class="trans-td-text">{{item.miner}}</div>
          </td>-->
         <td class="text-left">
            <div class="">
              {{item.validatorName}}
              <div>
                <router-link :to="`/validators/${item.account}`">{{item.account}}</router-link>
              </div>
            </div>
          </td>
          <td class="text-left">
            <div class="trans-td-text trans-from-text block-gas">
              <div>{{ (item.gasUsed || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}}<span>({{parseFloat(item.gasUsed/item.gasLimit * 100).toFixed(2)}}%)</span></div>
              <div class="block-gas-line">
                <div class="block-gas-line-bg" :style="{width:parseFloat(item.gasUsed/item.gasLimit * 100).toFixed(2)+'%'}"></div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import paginationSp from '@/views/_comp/pagination_sp.vue'
import { updateAge } from '@/util/index'
// import btnSortArr from '@/views/_comp/btn_sort_arr.vue'

export default {
  name: 'blockTable',
  components: {
    paginationSp,
    // btnSortArr,
  },
  props: [
    'page',
    'cfg',
  ],
  data() {
    return {
      total: 0,
      option1:10,
      showRecordPage:false,//显示数据tab
      nowRecordPage:25,//当前显示数据
      recordPage:[
        {num:25},
        {num:50},
        {num:75},
        {num:100}
      ],//一页多少数据
      showImg:0,
      cfg_pagination: {
        'page_size': 25, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 10000, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      data_onshow: [
      ],

      contract:'',
      bykey:'',
      pairlist:''
    }
  },
  computed: {},
  watch: {},
  methods: {
    updateTimestamp(val) {
      return updateAge(val)
    },
    //选择当前一页多少数据
    actionSelectPage(item) {
      let v = this
      v.nowRecordPage=item.num
      v.cfg_pagination.page_size=item.num
      v.showRecordPage=false
      // console.log(v.showRecordPage)
      v.initData()
    },
    initData(){
      let v = this

      // if(!v.data)return

      // 过滤数据
      v.getList()
      v.cfg_pagination.page_current = 1
      // if(v.total < 10000){
      //   v.cfg_pagination.count_items = v.total
      // }


    },

    async getList(){
      let v = this
      // 过滤条目
      let start = v.cfg_pagination.page_current
      let end =  v.cfg_pagination.page_size
      // v.data_onshow = v.data.slice(start, end)
      //
      // console.log(v.data_onshow)
      let result = await v.api('blockList', {
        page: start,
        size: end
      }, {
        vue: v,
        key_data: 'data',
      })
      if(result.code == 200){
        v.data_onshow = result.data.blocksList
        v.total = result.data.total
      }
      // 计算页码
      if(v.total < 10000){
        v.cfg_pagination.count_pages = Math.ceil(v.total/v.cfg_pagination.page_size)
      }else{
        v.cfg_pagination.count_pages = Math.ceil(10000/v.cfg_pagination.page_size)
      }

    },
  },
  created() {
    // console.log(this.data, "this.data=======")
    this.initData()
  },
  mounted() {
  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};

// import paginationSp from '@/views/_comp/pagination_sp.vue'
// import { updateAge } from '@/util/index'
// // import btnSortArr from '@/views/_comp/btn_sort_arr.vue'
//
// export default {
//   name: 'blockTable',
//   components: {
//     paginationSp,
//     // btnSortArr,
//   },
//   // props: [
//   //   'data',
//   //   'page',
//   //   'cfg',
//   // ],
//   data() {
//     return {
//       option1:10,
//       showRecordPage:false,//显示数据tab
//       nowRecordPage:25,//当前显示数据
//       recordPage:[
//         {num:25},
//         {num:50},
//         {num:75},
//         {num:100}
//       ],//一页多少数据
//       showImg:0,
//       cfg_pagination: {
//         'page_size': 25, //每页条目数量
//         'page_current': 1, // 当前页
//         'count_items': 0, //总个数，和总页数选填其一
//         'btn_num': 5, // 按钮个数
//         'turnpage_top': true, // 翻页时操作滚动置顶
//         'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
//       },
//       data_onshow: [
//         {}
//       ],
//
//       contract:'',
//       bykey:'',
//       pairlist:''
//     }
//   },
//   computed: {},
//   watch: {},
//   methods: {
//     updateTimestamp(val) {
//       return updateAge(val)
//     },
//     //选择当前一页多少数据
//     actionSelectPage(item) {
//       let v = this
//       v.nowRecordPage=item.num
//       v.cfg_pagination.page_size=item.num
//       v.showRecordPage=false
//       console.log(v.showRecordPage)
//       v.initData()
//     },
//     //跳转地址
//     goAddress(item) {
//       var address= item.address
//       this.$router.push(
//           {
//             path:"/address",
//             query:{address:address}
//           }
//       )
//     },
//     initData(){
//       let v = this
//       //
//       // v.cfg_pagination.page_current = 1
//       //
//       // // 计算页码
//       // v.cfg_pagination.count_pages = Math.ceil(v.cfg_pagination.count_items/v.cfg_pagination.page_size)
//       v.getList()
//
//     },
//
//     getList(){
//       let v = this
//       // 过滤条目
//       let start = v.cfg_pagination.page_current
//       let end = v.cfg_pagination.page_size
//       v.api('blockList', {
//         page: start,
//         size: end
//       }, {
//         vue: v,
//         key_data: 'data',
//       }).then(function (res) {
//         console.log('blocksList',res)
//         if (res.code==200) {
//           v.data_onshow = res.data.blocksList
//           v.cfg_pagination.count_items = res.data.total
//           v.cfg_pagination.count_pages = Math.ceil(res.data.total/v.cfg_pagination.page_size)
//         }
//       })
//
//     },
//   },
//   created() {
//     this.initData()
//   },
//   mounted() {
//     console.log(this.page,'======')
//   },
// };
</script>

<style lang="scss" scoped>

.block-icon-img {
  width: 21px;
  height: 24px;
  background: url("../../images/block/block-black.png")no-repeat;
  background-size: 100% auto;
}


.block-gas {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.block-gas-line {
  width: 90%;
  height: 8px;
  background: rgba(0,0,0,0.05);
  border-radius: 5px;
  margin-top: 10px;
}

.block-gas-line-bg {
  height: 8px;
  border-radius: 5px;
  background: #3772ff;
}




</style>
